import { IconButton } from '@monorepo/shared/componentsV2/Button/IconButton';
import { StyledFormGroup } from '@monorepo/shared/componentsV2/styled/form';
import { VisuallyHidden } from '@monorepo/shared/componentsV2/VisuallyHidden';
import TrashIcon from '@svg/trash.svg';
import { DatasetResponse } from 'mapistry-shared';
import React from 'react';
import styled from 'styled-components';
import { ConditionPicker } from './ConditionPicker';

const StyledEqualsText = styled.div<{
  $shouldLabelShow: boolean;
}>`
  margin-top: ${({ $shouldLabelShow }) =>
    $shouldLabelShow
      ? '1.7rem'
      : '0.6rem'}; /* lines this up vertically with the input elements to its left */
`;

const StyledConditionDeleteButton = styled(IconButton)<{
  $shouldLabelShow: boolean;
}>`
  min-width: 2rem;
  margin-top: ${({ $shouldLabelShow }) =>
    $shouldLabelShow
      ? '1.2rem'
      : '0'}; /* lines this up vertically with the input elements to its left */

  font-size: 0.75rem;
`;

interface StepConditionProps {
  formFieldName: string;
  leftDataset: DatasetResponse;
  rightDataset?: DatasetResponse;
  shouldLabelShow: boolean;
  canDelete: boolean;
  onDelete: () => void;
}

export function StepCondition({
  formFieldName,
  leftDataset,
  rightDataset,
  shouldLabelShow,
  canDelete,
  onDelete,
}: StepConditionProps) {
  return (
    <StyledFormGroup row>
      <ConditionPicker
        shouldLabelShow={shouldLabelShow}
        label="Field 1"
        dataset={leftDataset}
        fieldName={`${formFieldName}.leftPropertyId`}
      />

      <StyledEqualsText $shouldLabelShow={shouldLabelShow}>
        equals
      </StyledEqualsText>

      <ConditionPicker
        shouldLabelShow={shouldLabelShow}
        label="Field 2"
        dataset={rightDataset}
        fieldName={`${formFieldName}.rightPropertyId`}
      />

      {canDelete && (
        <StyledConditionDeleteButton
          onClick={onDelete}
          $shouldLabelShow={shouldLabelShow}
        >
          <TrashIcon />
          <VisuallyHidden>Delete condition</VisuallyHidden>
        </StyledConditionDeleteButton>
      )}
    </StyledFormGroup>
  );
}
